import axios from 'axios'

import { store } from '../../config/redux'
import { setCommonError } from '../Common/actions'
import { logout } from '../Auth/actions'
import { constants } from '../../constants'
import { language } from '../../context/LanguageContext/strings'
import { util } from '../../util'

const METHODS_WITH_BODY = ['POST', 'PUT', 'PATCH', 'DELETE']

const fetchData = (url, requestInfo) =>
    axios({
        method: requestInfo.method,
        url: url,
        headers: requestInfo.headers,
        data: requestInfo.body,
        timeout: 30000, // 30 seconds
    })

/**
 *
 * @param url {String} Endpoint URL
 * @param method {String} RESTFul api method
 * @param request {Object} data of the request body
 * @param options {Object}
 * @returns {Promise<AxiosResponse<any>>}
 */
export const api = async (url, method, request, options = {}) => {
    const {
        auth: { idToken, expires_at },
    } = store.getState()

    const defaultHeaders = {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
        'Accept-Language': language,
    }

    if (idToken) {
        defaultHeaders.Authorization = `Bearer ${idToken}`
    }

    const timeDiff = util.sessionExpiresInMS(expires_at)

    /** if the session expires then logout the user */
    if (timeDiff < 0) {
        store.dispatch(logout())
        return
    }

    const requestInfo = {
        method,
        headers: options.customHeaders || defaultHeaders,
    }

    if (METHODS_WITH_BODY.includes(method) && request) {
        requestInfo.body = options.isFile ? request : JSON.stringify(request)
    }

    try {
        return await fetchData(url, requestInfo)
    } catch (err) {
        if (options.justThrowError) throw err

        /** Server Timeout Error handling */
        if (err.code && err.code === 'ECONNABORTED') {
            const error = 'Server Timeout, Please try again.'
            store.dispatch(setCommonError(error))
        }
        const error = err.response ? err.response.data.message : err.message ? err.message : ''
        const errorKey = error.replace(/ /g, '_')
        let isCommonError = constants.networkErrors[errorKey]
        if (err.response && err.response.status === 500) {
            isCommonError = constants.networkErrors.genericError
        }
        /**
         * Common Error are like Network Errors, Internal Server Error etc
         * Which are common irrespective to page which is the reason why we
         * created a separate set of actions and reducer
         */
        if (isCommonError && isCommonError.length && (!options || !options.hasCustomError)) {
            store.dispatch(setCommonError(isCommonError))
            throw err.response
        } else {
            console.log({ ...err })
            throw err.response
        }
    }
}
